<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-auto my-2 card boxStyle"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "langType",
    data() {
        return {
            selectedImage: [],
            img: [
                {id:'3',name:'فارسی',value:'persian',full_path:require('../../../../public/media/site/lang/فارسی.png')},
                {id:'1',name:'انگلیسی',value:'english',full_path:require('../../../../public/media/site/lang/انگلیسی.png')},
                {id:'2',name:'فارسی+انگلیسی',value:'both',full_path:require('../../../../public/media/site/lang/فارسی+انگلیسی.png')},
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"langType")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>